import React, { useState, useEffect, useMemo } from "react";
import { getRules } from "../../../../api/lead-assignment";
import { useSetLoading } from "../../../../common/hooks/appearance";
import { MUITable } from "../../../../common/components";
import { BreadcrumbComponent } from "../../../../common/components";
import "../lead-assignment.scss";
import { routes } from "../../../../constants/routes";
import { PaginationComponent } from "../../../../common/components";
import { Link } from "react-router-dom";
import moment from "moment";
import { convertUTCToLocal } from "../../../../utils/utils";

const ArchivedRules = () => {
  const breadcrumbLink = [
    { label: "Lead Assignment", link: `${routes.ASSIGNMENTRULES}` },
    { label: "Assignment Rules", link: `${routes.ASSIGNMENTRULES}` },
    { label: "Archived Rules", link: "#", handleClick: () => {} },
  ];
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [pageSize] = useState<number>(15);
  const [currentPage, setCurrentPage] = useState<number>(1);

  const fetchRules = async (page = 1, deletedRules: boolean = true) => {
    setLoading(true);
    try {
      const offset = (page - 1) * pageSize;
      const params: any = {
        limit: pageSize,
        offset: offset,
      };
      if (deletedRules) {
        params.deletedRules = true;
      }
      const response = await getRules(params);
      setData(response.data.data.result);
      setTotalRecords(response.data.data.totalRecords);
      setTimeout(() => setLoading(false), 1000);
    } catch (error) {
      setLoading(false);
    }
  };

  const headers = [
    { key: "logicTitle", label: "Logic Title", isOnClick: false },
    { key: "dateCreated", label: "Date Created" },
    { key: "status", label: "Status" },
    { key: "leads", label: "Leads" },
    { key: "lastRun", label: "Last Run" },
  ];

  const formattedData = useMemo(() => {
    if (Array.isArray(data)) {
      return data.map((item: any) => {
        return {
          id: item.id,
          logicTitle: item.rule_name || "-",
          dateCreated: item.created_at
            ? new Date(item.created_at).toLocaleDateString()
            : "-",
          status: item.is_active ? "Active" : "Inactive",
          leads: item._count?.assignedLeads ?? 0,
          lastRun: item.last_run_at
            ? convertUTCToLocal(item.last_run_at, "MM-DD-YYYY hh:mm A")
            : "-",
        };
      });
    }
    return [];
  }, [data]);

  useEffect(() => {
    fetchRules(currentPage);
  }, [currentPage]);

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPage(value);
  };

  const showLoading = useMemo(() => loading, [loading]);
  useSetLoading(showLoading);

  return (
    <>
      <div className="leadlist-wrapper assignment-rules-leads-wrapper lead-assignment-rules-wrapper">
        <div className="breadcrumb-wrapper">
          <BreadcrumbComponent breadcrumbLink={breadcrumbLink} />
        </div>
        <div className="lead-list-table assignment-rules-leads-list-table archived-rules-list-table">
          <MUITable
            headers={headers}
            data={formattedData.map((item: any) => ({
              id: item?.id,
              logicTitle: item.logicTitle,
              dateCreated: item.dateCreated,
              status: (
                <span
                  style={{
                    color: item.status === "Active" ? "green" : "red",
                  }}
                >
                  {item.status}
                </span>
              ),
              leads: <span className="leads-link">{item.leads}</span>,
              lastRun: item.lastRun,
              leadCount: item?.leads,
            }))}
            noResultsTxt={"No Archived rules found"}
            onColumnClick={(row) => {
              // handleViewRule(row);
            }}
          />
        </div>
        {totalRecords && totalRecords > 0 ? (
          <div className="leads-pagination-container">
            <PaginationComponent
              totalRecords={totalRecords}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default ArchivedRules;
